var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBomb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.44 10.56L11.2322 14.3522L5.82856 17.5086L12.1305 16.5039L6.96256 24.9626L14.9118 18.5918L17.918 27.5713L18.3577 18.7844L25.9642 23.3242L20.812 16.892L26.3144 16.9544L21.6093 14.4359L29.0226 7.02261L19.8408 11.0141L23.0487 4.46204L17.8887 9.62204L17.4874 1.06074L15.2167 9.05675L9.41481 5.49482L12.6949 10.4549L3.44 10.56Z",
    fill: "#3A7EFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.1334,
    y: 14.3984,
    width: 1.73333,
    height: 6.06667,
    fill: "#E1E1E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 17.8672,
    width: 26,
    height: 12.1333,
    rx: 1,
    fill: "#EAEAEA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.70526,
    y: 20.4453,
    width: 2.13153,
    height: 1.10839,
    rx: 0.554197,
    fill: "#B5B5B5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.11469,
    y: 20.4453,
    width: 2.13153,
    height: 1.10839,
    rx: 0.554197,
    fill: "#B5B5B5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.52618,
    y: 20.4453,
    width: 2.13153,
    height: 1.10839,
    rx: 0.554197,
    fill: "#B5B5B5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9346,
    y: 20.4453,
    width: 2.13153,
    height: 1.10839,
    rx: 0.554197,
    fill: "#B5B5B5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3464,
    y: 20.4453,
    width: 2.13153,
    height: 1.10839,
    rx: 0.554197,
    fill: "#B5B5B5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7562,
    y: 20.4453,
    width: 2.13153,
    height: 1.10839,
    rx: 0.554197,
    fill: "#B5B5B5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1682,
    y: 20.4453,
    width: 2.13153,
    height: 1.10839,
    rx: 0.554197,
    fill: "#B5B5B5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1.70526,
    y: 22.9766,
    width: 2.13153,
    height: 1.10839,
    rx: 0.554197,
    fill: "#B5B5B5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 5.11469,
    y: 22.9766,
    width: 2.13153,
    height: 1.10839,
    rx: 0.554197,
    fill: "#B5B5B5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 8.52618,
    y: 22.9766,
    width: 2.13153,
    height: 1.10839,
    rx: 0.554197,
    fill: "#B5B5B5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9346,
    y: 22.9766,
    width: 2.13153,
    height: 1.10839,
    rx: 0.554197,
    fill: "#B5B5B5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3464,
    y: 22.9766,
    width: 2.13153,
    height: 1.10839,
    rx: 0.554197,
    fill: "#B5B5B5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7562,
    y: 22.9766,
    width: 2.13153,
    height: 1.10839,
    rx: 0.554197,
    fill: "#B5B5B5"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1682,
    y: 22.9766,
    width: 2.13153,
    height: 1.10839,
    rx: 0.554197,
    fill: "#B5B5B5"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1.70587,
    y: 26.4141,
    width: 5.54197,
    height: 1.10839,
    rx: 0.554197,
    fill: "#B5B5B5"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7587,
    y: 26.4141,
    width: 5.54197,
    height: 1.10839,
    rx: 0.554197,
    fill: "#B5B5B5"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 8.52795,
    y: 26.4141,
    width: 8.95241,
    height: 1.10839,
    rx: 0.554197,
    fill: "#B5B5B5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBomb);
export default __webpack_public_path__ + "static/media/IcBomb.99ef53a737c25f2d0613c196323aa283.svg";
export { ForwardRef as ReactComponent };